import { FC } from 'react'
import { keywordHelperContainer, keywordHelperText, keywordHelperTextUnderlined } from '../areasOfExpertise.css'

type AreaOfExpertiseTitleProps = {
  isFullView: boolean
  summaryCountReviews: number
  translate: (key: string, options?: { [key: string]: number }) => string
}

const AreaOfExpertiseTitle: FC<AreaOfExpertiseTitleProps> = ({ isFullView, summaryCountReviews, translate }) => {
  return isFullView ? (
    <div className={keywordHelperContainer}>
      {summaryCountReviews ? (
        <span className={keywordHelperTextUnderlined}>
          {translate('profile.areas-of-expertise.patient-reviews', { number: summaryCountReviews })}
        </span>
      ) : null}
      <span className={keywordHelperText}>{translate('profile.areas-of-expertise.patient-reviews.tip')}</span>
    </div>
  ) : null
}

export default AreaOfExpertiseTitle
